export default __webpack_public_path__ + "static/media/17.04fb29ca.svg";